import { generateRoundedRange } from '../calculation'

interface ComposePayRangeResult {
  label: string
  start: number
  end?: number
}

export function composePayRangeValues({
  min,
  max,
}: {
  min: number
  max: number
}): ComposePayRangeResult[] {
  const values = generateRoundedRange(min, max)
  const result: ComposePayRangeResult[] = []

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < values.length; i++) {
    const start = values[i]
    const end = values[i + 1] || max
    result.push({
      label: `${start} - ${end}`,
      start,
      // end,
    })
  }
  return result
}

export function findPayRangeItem<T extends { label: string }>({
  nbr,
  items,
}: {
  nbr: number
  items: T[]
}) {
  return items.find(({ label }) => {
    const [start, end] = label.split(' - ')
    return nbr >= +start && nbr <= +end
  })
}
